import { cn } from '@/utlis/cn'
import { MouseEventHandler } from 'react'

export default function InternalButton({
    className,
    children,
    onClick,
    title,
}: {
    className?: string
    children: React.ReactNode
    onClick: MouseEventHandler<HTMLButtonElement>
    title?: string
}) {
    return (
        <button className={cn('cursor-pointer px-1 h-full', className)} onClick={onClick} title={title}>
            {children}
        </button>
    )
}
